import { createBrowserRouter } from 'react-router-dom'

import AppLayout from '../components/AppLayout'
import {
  LazyHomePageGuard,
  LazySurveyPage,
  LazySurveyReviewPage,
  LazyCompletePage,
  LazyErrorPage,
  LazyPageNotFound,
} from '../components/LazyComponents'

export const AppRoutes = createBrowserRouter([
  {
    path: '/',
    Component: AppLayout,
    children: [
      { index: true, Component: LazyHomePageGuard },
      {
        path: 'survey',
        Component: LazySurveyPage,
      },
      {
        path: 'review',
        Component: LazySurveyReviewPage,
      },
      {
        path: 'complete',
        Component: LazyCompletePage,
      },
      { path: 'error', Component: LazyErrorPage },
      { path: '*', Component: LazyPageNotFound },
    ],
  },
])
